export default __webpack_public_path__ + "static/media/IMG_5806.eb3dd0ab.JPG";